import { SpeakingSlotStatus, SpeakingSlotType } from 'api/planning';

export const getSlotCapacityForStatus = (
  speakingSlotType: SpeakingSlotType,
  status: SpeakingSlotStatus,
  plannedCapacity: number
) => {
  if (speakingSlotType === SpeakingSlotType.SWA) {
    return status === SpeakingSlotStatus.Break ? 0 : plannedCapacity;
  }

  return status === SpeakingSlotStatus.Break ? 0 : 1;
};
